import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
  deleteOperacaoBatelada,
} from './actions';

export function* requestOperacaoBateladas({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'bateladas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaobatelada, params } = payload;

    yield call(api.post, 'bateladas', operacaobatelada);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/batelada');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `bateladas/${id}`);

    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaobatelada, params } = payload;

    yield call(api.put, 'bateladas', operacaobatelada);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/batelada');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'bateladas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyUpdate({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, 'bateladas/altera', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/batelada');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaobatelada/OPERACAOBATELADAS_IN_REQUEST',
    requestOperacaoBateladas
  ),
  takeLatest(
    '@operacaobatelada/DELETE_OPERACAOBATELADA',
    deleteOperacaoBatelada
  ),
  takeLatest('@operacaobatelada/SUCCESS_REMOVE', requestOperacaoBateladas),
  takeLatest('@operacaobatelada/STORE_OPERACAOBATELADA', store),
  takeLatest('@operacaobatelada/FIND_OPERACAOBATELADA', find),
  takeLatest('@operacaobatelada/UPDATE_OPERACAOBATELADA', update),
  takeLatest('@operacaobatelada/RECORD_FILTERING', applyedFilters),
  takeLatest('@operacaobatelada/UPDATE', applyUpdate),
]);
